<template>
  <div
    v-if="isVisible && rect"
    class="absolute border-2 border-primary bg-primary/10 pointer-events-none z-50"
    :style="{
      left: `${rect.left}px`,
      top: `${rect.top}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`
    }"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  isVisible: boolean
  startX: number
  startY: number
  endX: number
  endY: number
}

const props = defineProps<Props>()

const rect = computed(() => {
  if (!props.isVisible) return null

  return {
    left: Math.min(props.startX, props.endX),
    top: Math.min(props.startY, props.endY),
    width: Math.abs(props.endX - props.startX),
    height: Math.abs(props.endY - props.startY)
  }
})
</script>
